// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/depreciation-schedules',
        component: () =>
            import(/* webpackChunkName: "accounting.asset-depreciation-schedule" */ '@/pages/[organisation]/accounting/asset-depreciation-schedule/asset-depreciation-schedules.vue'),
        name: 'accounting.asset-depreciation-schedule.search-asset-depreciation-schedules',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.asset-depreciation-schedule.view-asset-depreciation-schedules',
        },
    },
];
